<template>
  <main-layout>
    <div>
      <v-container class="px-5">
        <div v-ripple class="addquestiontero mb-4" @click="onAdd">
          <div class="text-xs-center" style="font-size: 22px">
            <em class="fas fa-plus" />
            เพิ่มชุดคำถาม
          </div>
        </div>
        <div>
          <intent-item
            v-for="(item, index) in intents"
            :key="'intent_' + item.id + '_' + index"
            v-model="intents[index]"
            :filter-intents="intents"
            @onEdit="onEdit(item, index)"
            @onDelete="onDelete(item, index)"
          ></intent-item>
          <!-- <div v-for="item in intents" :key="item.id">
            {{ item.intentname }}
          </div> -->
        </div>
        <div>
          <v-dialog v-model="showEdit" persistent width="700px">
            <AddQuestion
              v-if="showEdit"
              :excluded-name="excludedName"
              :type="intenttype"
              :inputvalue="inputvalue"
              @dataChange="onChange"
              @close="showEdit = false"
            ></AddQuestion>
          </v-dialog>
        </div>
      </v-container>
    </div>
  </main-layout>
</template>
<script>
import AddQuestion from './AddQuestion.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import IntentItem from './IntentItem.vue'
import moment from 'moment'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    AddQuestion,
    IntentItem
  },
  computed: {
    ...mapGetters(['selectedBot']),
    excludedName() {
      return this.intents.map((el) => el.intentname)
    }
  },
  data() {
    return {
      intenttype: '',
      inputvalue: '',
      showEdit: false,
      intents: [],
      fullIntents: []
    }
  },
  mounted() {
    this.$store.dispatch('loading')
    this.getIntent()
  },
  methods: {
    onChange() {
      this.$store.dispatch('loading')
      this.getIntent()
    },
    onAdd() {
      this.intenttype = 'add'
      this.showEdit = true
    },
    onEdit(item, index) {
      var answerChoice = this.fullIntents.find(
        (el) => el.intentname == 'Answer__' + item.intentname
      )
      var commentQuestion = this.fullIntents.find(
        (el) => el.intentname == 'Comment__' + item.intentname
      )

      this.inputvalue = {
        id_question: item.id,
        id_answer: answerChoice.id,
        id_comment: commentQuestion.id,
        startDate: moment(item.starttime).format('YYYY-MM-DD'),
        startTime: moment(item.starttime).format('HH:mm'),
        endDate: moment(item.endtime).format('YYYY-MM-DD'),
        endTime: moment(item.endtime).format('HH:mm'),
        answerinput: item.quick_reply.split(','),
        question_messages: JSON.parse(item.a_val),
        answer_messages: JSON.parse(answerChoice.a_val),
        tags: item.q_val.split(',').map((el) => {
          return { text: el }
        }),
        input: {
          question: item.intentname
        }
      }

      this.intenttype = 'edit'
      this.showEdit = true
    },
    onDelete(item, index) {
      var vm = this
      var answerChoice = this.fullIntents.find(
        (el) => el.intentname == 'Answer__' + item.intentname
      )
      var commentQuestion = this.fullIntents.find(
        (el) => el.intentname == 'Comment__' + item.intentname
      )

      var id_question = item.id
      var id_answer = answerChoice.id
      var id_comment = commentQuestion.id
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ',
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var arr = [id_question, id_answer, id_comment]
            var delArr = arr.map((el) => {
              return new Promise((resolve) => {
                api.deleteIntent({ pageid: this.selectedBot.pageid, id: el }, (err, response) => {
                  resolve()
                })
              })
            })
            vm.$store.dispatch('loading')
            Promise.all(delArr).then(() => {
              vm.getIntent()
            })
          }
        })
    },
    async getIntent() {
      const vm = this
      let params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)

        if (response.data.data) {
          const data = response.data.data
          vm.$store.dispatch('loading')
          const filterDefaultIntents = data.filter((el) => {
            const result =
              !['{welcome}', '{default}', '{default_comment_to_inbox}', ,].includes(
                el.intentname
              ) && el.intentname.includes('Question__')

            return result
          })
          vm.intents = filterDefaultIntents.map((el) => {
            let a_val = JSON.parse(el.a_val)
            if (a_val[0]) {
              const agetopicindex = a_val[0].findIndex((val) => {
                return (
                  val &&
                  val.text &&
                  (val.text.includes('checkagetopic') || val.text.includes('saveanswertopic'))
                )
              })
              if (agetopicindex !== -1) {
                a_val[0].splice(agetopicindex, 1)
              }
            }
            a_val = JSON.stringify(a_val)
            const result = { ...el, a_val, intentname: el.intentname.replace('Question__', '') }
            return result
          })
          vm.fullIntents = data.map((el) => {
            var a_val = JSON.parse(el.a_val)
            if (a_val[0]) {
              var agetopicindex = a_val[0].findIndex((val) => {
                return (
                  val &&
                  val.text &&
                  (val.text.includes('checkagetopic') || val.text.includes('saveanswertopic'))
                )
              })
              if (agetopicindex !== -1) {
                a_val[0].splice(agetopicindex, 1)
              }
            }
            a_val = JSON.stringify(a_val)
            return { ...el, a_val }
          })
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>
<style lang="scss">
.addquestiontero {
  border: 3px dashed #eee;
  height: 80px;
  cursor: pointer;
  border-radius: 10px;
  line-height: 80px;
}
.addquestiontero:hover {
  border: 3px dashed grey !important;
  color: grey !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/tero/main.vue